import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Checkbox, Button } from '@mui/material';
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';


const CadetesParaFranco = ({ datosCadetes, tipo,finalizo }) => {
  // Estado para almacenar los DNIs seleccionados
  const Usuario=ObtieneDatosCookies()
  const [seleccionados, setSeleccionados] = useState([]);
  const [puedo, setPuedo] = useState(false);
  const [selectAllState, setSelectAllState] = useState('indeterminate'); // 'checked', 'unchecked', 'indeterminate'
// console.log(datosCadetes)
  const manejarCambio = (dni) => {
    setSeleccionados((prevSeleccionados) => {
      const nuevosSeleccionados = prevSeleccionados.includes(dni)
        ? prevSeleccionados.filter((item) => item !== dni)
        : [...prevSeleccionados, dni];

      // Verificar si hay algún DNI seleccionado
      setPuedo(nuevosSeleccionados.length > 0);
      return nuevosSeleccionados;
    });
  };

  const manejarEnvio = async () => {
    const cadetesIncluidos = seleccionados.join(';');
    const datos = { cadetesIncluidos, usuarioId:Usuario.id , sede: "Rosario", seccionId: "1" };
    const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
    const client = axios.create({
      baseURL: `${process.env.REACT_APP_BASEURL}Ncadetes/creaFrancoPorGrupos`,
      headers: {
        Authorization: `Basic ${token}`,
      },
    });

    try {
      const response = await client.post("/", datos);
      if (response.data.success) {
        Swal.fire("Se ha dado de franco al listado de cadetes Suministrado", "Tenga en cuenta que esta accion no puede deshacerse", "success");
        finalizo("exito")
        setSeleccionados([]);
        setPuedo(false)
      } else {
        Swal.fire("No se pudo dar franco al grupo de cadetes pasado ya que anteriormente se hizo o los mismos no tenian presente el dia de hoy", "Si considera que es un error comuniquese con DTyD", "error");
//         console.log(response.data);
      }
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
    }
  };

  const manejarSelectAll = () => {
    if (selectAllState === 'unchecked') {
      setSeleccionados(datosCadetes.map((fila) => fila.cadeteDni));
      setSelectAllState('checked');
      setPuedo(true);
    } else if (selectAllState === 'checked') {
      setSeleccionados([]);
      setSelectAllState('unchecked');
      setPuedo(false);
    } else {
      setSeleccionados(datosCadetes.map((fila) => fila.cadeteDni));
      setSelectAllState('checked');
    }
  };

  const manejarSelectChange = () => {
    if (seleccionados.length === 0) {
      setSelectAllState('unchecked');
      setPuedo(false)
    } else if (seleccionados.length === datosCadetes.length) {
      setSelectAllState('checked');
    } else {
      setSelectAllState('indeterminate');
    }
  };

  React.useEffect(() => {
    manejarSelectChange();
  }, [seleccionados]);

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Checkbox
                checked={selectAllState === 'checked'}
                indeterminate={selectAllState === 'indeterminate'}
                onChange={manejarSelectAll}
                inputProps={{ 'aria-label': 'select all cadetes' }}
              />
            </TableCell>
            <TableCell>Cadete</TableCell>
            <TableCell>DNI</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datosCadetes.map((fila) => (
            <TableRow key={fila.cadeteDni}  >
              <TableCell>
                <Checkbox
                  checked={seleccionados.includes(fila.cadeteDni)}
                  onChange={() => manejarCambio(fila.cadeteDni)}
                  inputProps={{ 'aria-label': `select cadete ${fila.cadeteDni}` }}
                />
              </TableCell>
//               {console.log(fila)}
              <TableCell>{fila.cadete.cadeteApellido} {fila.cadete.cadeteNombre}</TableCell>
             
              <TableCell>{fila.cadeteDni}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {puedo ? (
        <Button onClick={manejarEnvio} variant="contained" color="primary">
          Enviar Seleccionados
        </Button>
      ) : (
        <Button onClick={manejarEnvio} variant="contained" disabled color="primary">
          Enviar Seleccionados
        </Button>
      )}
    </div>
  );
};

export default CadetesParaFranco;
